import { httpReservation } from 'shared/services/http/httpClient';
import {
  AppUserRatingsFilters,
  AppUserRatingsResponse,
  AppUserRatingsStats
} from '../models/appUserRatingsModels';

const buildFilterParams = (filters?: AppUserRatingsFilters): Record<string, any> => {
  const params: Record<string, any> = {};
  if (filters?.dateFrom) params.date_from = filters.dateFrom.format('YYYY-MM-DD');
  if (filters?.dateTo) params.date_to = filters.dateTo.format('YYYY-MM-DD');
  if (filters?.transfer_reservation_id != null) params.transfer_reservation_id = filters.transfer_reservation_id;
  if (filters?.driver_id != null) params.driver_id = filters.driver_id;
  if (filters?.score_min != null) params.score_min = filters.score_min;
  if (filters?.score_max != null) params.score_max = filters.score_max;
  if (filters?.client_id != null) params.client_id = filters.client_id;
  if (filters?.client_type && filters.client_type !== 'AllClient') params.client_type = filters.client_type;
  return params;
};

export const appUserRatingsService = () => {
  const getRatings = async (
    page: number = 1,
    page_size: number = 10,
    sort: string = 'created_at',
    sort_dir: string = 'DESC',
    filters?: AppUserRatingsFilters
  ): Promise<AppUserRatingsResponse> => {
    const params = { page, page_size, sort, sort_dir, ...buildFilterParams(filters) };
    const res = await httpReservation.get('booking/rating', { params });
    return res as unknown as AppUserRatingsResponse;
  };

  const getStats = async (filters?: AppUserRatingsFilters): Promise<AppUserRatingsStats> => {
    const res = await httpReservation.get('booking/rating/stats', { params: buildFilterParams(filters) });
    return res as unknown as AppUserRatingsStats;
  };

  return { getRatings, getStats };
};
